module.exports = __webpack_public_path__ + "img/cbt-empty.129521df.svg";